import { render, staticRenderFns } from "./vistaComplementosDeudor.vue?vue&type=template&id=23b8aee2"
import script from "./vistaComplementosDeudor.vue?vue&type=script&lang=js"
export * from "./vistaComplementosDeudor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports